import {
  Modal,
  Platform,
  TouchableOpacity,
  TouchableWithoutFeedback,
} from 'react-native';
import React, {forwardRef, useImperativeHandle, useState} from 'react';
import {useTheme} from 'contexts/ThemeContext';
import styleSheet from './styles';

export interface PopUpHandle {
  switchVisible(): void;
}

export interface PopUpProps {
  children: JSX.Element;
  backDropStyle?: object;
}

const PopUp = forwardRef<PopUpHandle, PopUpProps>((props, ref) => {
  const styles = styleSheet(useTheme());

  const [isPopUp, setIsPopUp] = useState(false);

  useImperativeHandle(ref, () => ({
    switchVisible() {
      setIsPopUp(!isPopUp);
    },
  }));

  const onPressOut = () => {
    setIsPopUp(!isPopUp);
  };

  return (
    <Modal
      animationType={Platform.OS !== 'web' ? 'slide' : 'none'}
      transparent
      visible={isPopUp}>
      <TouchableOpacity
        activeOpacity={1}
        onPress={onPressOut}
        style={[styles.defaultBackDropStyle, props.backDropStyle]}>
        <TouchableWithoutFeedback>{props.children}</TouchableWithoutFeedback>
      </TouchableOpacity>
    </Modal>
  );
});

export default PopUp;
